import styled from 'styled-components';

export const ApplyBlock = styled('div')`
  height: 10%;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  & .error {
    width: 20%;
    color: red;
  }
`;

export const ApplyLeftBlock = styled('div')`
  display: flex;
  align-items: center;
  gap: 10px;

  & .error {
    width: 40%;
    color: red;
  }
`;

export const QrPreviewButton = styled('button')`
  border: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;
  display: flex;

  & img {
    display: block;
  }
`;

export const QrModalContent = styled('div')`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  padding: 16px;
  border-radius: 12px;
  background: #fff;

  outline: none;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const QrBig = styled('img')`
  width: 360px;
  height: 360px;
  max-width: 80vw;
  max-height: 80vh;
`;
